'use strict';

exports.__esModule = true;
exports.BasicInput = exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _connectField = require('./connectField');

var _connectField2 = _interopRequireDefault(_connectField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Field = function (_Component) {
  (0, _inherits3.default)(Field, _Component);

  function Field() {
    (0, _classCallCheck3.default)(this, Field);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  Field.prototype.render = function render() {
    var _props = this.props,
        name = _props.name,
        component = _props.component;

    var FieldInput = (0, _connectField2.default)(name, this.props)(component || BasicInput);

    return _react2.default.createElement(FieldInput, null);
  };

  return Field;
}(_react.Component);

Field.propTypes = {
  component: _propTypes2.default.any,
  name: _propTypes2.default.string.isRequired
};
exports.default = Field;

var BasicInput = exports.BasicInput = function (_Component2) {
  (0, _inherits3.default)(BasicInput, _Component2);

  function BasicInput() {
    (0, _classCallCheck3.default)(this, BasicInput);
    return (0, _possibleConstructorReturn3.default)(this, _Component2.apply(this, arguments));
  }

  BasicInput.prototype.render = function render() {
    var _props2 = this.props,
        id = _props2.id,
        label = _props2.label,
        error = _props2.error,
        name = _props2.name,
        value = _props2.value,
        placeholder = _props2.placeholder,
        onBlur = _props2.onBlur,
        onChange = _props2.onChange,
        onFocus = _props2.onFocus;


    return _react2.default.createElement(
      'div',
      null,
      label && _react2.default.createElement(
        'label',
        { htmlFor: id },
        label
      ),
      _react2.default.createElement('input', (0, _extends3.default)({
        type: 'text'
      }, {
        id: id, name: name, value: value, placeholder: placeholder, onBlur: onBlur, onChange: onChange, onFocus: onFocus
      })),
      error && _react2.default.createElement(
        'div',
        { className: 'error' },
        error
      )
    );
  }; // eslint-disable-line


  return BasicInput;
}(_react.Component);

BasicInput.propTypes = {
  error: _propTypes2.default.string,
  id: _propTypes2.default.string,
  label: _propTypes2.default.string,
  name: _propTypes2.default.string,
  value: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func
};